var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("picture", [
    _c("source", {
      attrs: { media: _vm.media, "data-srcset": _vm.desktopSrcset },
    }),
    _vm._v(" "),
    _c("source", { attrs: { "data-srcset": _vm.mobileSrcset } }),
    _vm._v(" "),
    _c("img", {
      staticClass: "vpic lazyload",
      class: _vm.custom_class,
      attrs: {
        src: _vm.placeholder,
        alt: _vm.media.alt || _vm.$attrs.alt || "Banner",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }